var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClassManagementNav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 72,
    viewBox: "0 0 1920 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1920 0V70.4736L1880.62 70.426L1809.84 71.8046L1739.06 70.1567L1668.29 70.0563L1597.52 69.8609L1526.74 72L1455.97 70.5L1385.19 70.3046L1314.42 70.257L1243.65 70.426L1172.88 70.2782L1102.11 71.6039L1031.34 70.2042L960.57 71.1391L889.8 70.3521L819.02 71.3345L748.25 70.331L677.48 71.8521L606.71 70.9648L535.94 71.1866L465.17 70.1092L394.4 70.1303L323.63 71.5827L252.86 70.6743L182.09 69.8345L111.32 70.2306L40.55 71.213L0 71.0176V0H1920Z",
    fill: "#2E30E5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassManagementNav);
export default __webpack_public_path__ + "static/media/class_management_nav.aefdac66d559b3a6566494c4249bd05a.svg";
export { ForwardRef as ReactComponent };